import { Col, Container } from 'reactstrap'
import { Btn, Image, P } from '../../../../AbstractElements'
import { dynamicImage } from '../../../../Service'
import { CommonErrorPageType } from '../../../../Type/OtherPages/OtherPages'
import { BackToHomePage } from '../../../../utils/Constant'

const CommonError: React.FC<CommonErrorPageType> = ({ color, src }) => {
  return (
    <div className="page-wrapper compact-wrapper modern-type">
      <div className="error-wrapper">
        <Container className='error-pages'>
          <Image className="img-fluid" src={dynamicImage(`error/${src}.png`)} alt="otherimg" />
          <Col md="8" className="offset-md-2">
            <P className="sub-content">{"The page you are attempting to reach is currently not available. This may be because the page does not exist or has been moved."}</P>
          </Col>
          <div>
            <Btn size="lg" tag="a" color={`${color}`} href={`/dashboard/ecommerce`}>{BackToHomePage}</Btn>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default CommonError